import { get } from 'lodash';

export const getSortedIds = (ids, sortState, data) => {
  if (!Object.keys(sortState).length) {
    return ids;
  }
  const [sortType] = Object.values(sortState);
  const [sortFiled] = Object.keys(sortState);
  return ids.concat().sort((a, b) => {
    const aValue = get(data[a], sortFiled);
    const bValue = get(data[b], sortFiled);
    if (sortType === 'desc') {
      return bValue - aValue;
    }
    return aValue - bValue;
  });
};
